import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, makeStyles, shorthands } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { FC, PropsWithChildren, CSSProperties, useEffect } from 'react';

// it is a wrapper around the Fluent UI Dialog component
// all the items passed as children will be rendered inside the dialog

export interface CDialogProps {
    title?: string;
    icon?: () => JSX.Element;
    open: boolean;
    primaryActionText: string;
    secondaryActionText?: string;
    additionalActions?: Action[];
    containsForm?: boolean;
    disablePrimaryAction?: boolean;
    onSecondaryAction?: () => void;
    onPrimaryAction: () => void;
    dialogSurfaceStyle?: CSSProperties;
}

interface Action {
    text: string;
    onAction: () => void;
}

const useStyle = makeStyles({
    title: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...shorthands.gap('0.5rem'),
    },
});
export const CDialog: FC<PropsWithChildren<CDialogProps>> = (props: PropsWithChildren<CDialogProps>) => {
    const {
        icon,
        children,
        containsForm = false,
        open,
        title,
        onPrimaryAction,
        onSecondaryAction,
        additionalActions,
        disablePrimaryAction,
        primaryActionText,
        secondaryActionText,
        dialogSurfaceStyle,
    } = props;
    const classes = useStyle();

    // Add Escape key handler to close dialog
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && open && onSecondaryAction) {
                event.preventDefault();
                event.stopPropagation(); // Prevent event from bubbling up to close menu
                event.stopImmediatePropagation(); // Prevent other listeners on the same element
                onSecondaryAction();
            }
        };

        if (open) {
            // Use capture phase to ensure we handle the event first
            document.addEventListener('keydown', handleKeyDown, true);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [open, onSecondaryAction]);

    return (
        <Dialog open={open}>
            <DialogSurface style={dialogSurfaceStyle}>
                <DialogBody>
                    <DialogTitle
                    // action={
                    //     onSecondaryAction ? (
                    //         <DialogTrigger action='close'>
                    //             <Button appearance='subtle' aria-label='close' icon={<Dismiss24Regular />} onClick={onSecondaryAction} />
                    //         </DialogTrigger>
                    //     ) : null
                    // }
                    >
                        <div className={classes.title}>
                            {icon ? icon() : null}
                            {title}
                        </div>
                    </DialogTitle>
                    <DialogContent>{children}</DialogContent>
                    <DialogActions>
                        {secondaryActionText && (
                            <DialogTrigger action='close'>
                                <Button appearance='secondary' onClick={onSecondaryAction}>
                                    {secondaryActionText}
                                </Button>
                            </DialogTrigger>
                        )}
                        {additionalActions?.map((action, index) => (
                            <Button key={index} appearance='secondary' onClick={action.onAction}>
                                {action.text}
                            </Button>
                        ))}
                        <Button type={containsForm ? 'submit' : 'button'} disabled={disablePrimaryAction} appearance='primary' onClick={onPrimaryAction}>
                            {primaryActionText}
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};
